import { motion } from "framer-motion";
import { rem, rgba, size } from "polished";
import styled, { css } from "styled-components";
import media from "styled-media-query";

import { Ionicons } from "../../Icons";
import { IContentProps } from "./interfaces";

import { themes } from "styles";

export const Container = styled(motion.div)<IContentProps>`
  margin: 20px;

  border-radius: 8px;
  background-color: #fff;

  ${(props) =>
    props.size &&
    {
      medium: css`
        width: 100%;

        ${media.greaterThan("large")`
          width: 500px;
          margin: 40px auto;
        `}

        ${media.greaterThan("huge")`
          width: 700px;
        `}
      `,

      large: css`
        width: 100%;

        ${media.greaterThan("large")`
          width: 800px;
          margin: 40px auto;
        `}

        ${media.greaterThan("huge")`
          width: 1000px;
        `}
      `,
    }[props.size]}
`;

export const Head = styled.div`
  padding: 32px 32px 16px;

  display: flex;
  align-items: center;

  ${media.greaterThan("huge")`
    padding: 32px 32px 40px;
  `}
`;

export const Icon = styled(Ionicons)`
  ${size("30px")}

  margin-right: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;
  font-size: ${rem("14px")};
  color: ${themes.palletes.success};
  background-color: ${rgba(themes.palletes.success, 0.15)};

  ${media.greaterThan("huge")`
    ${size("40px")}

    font-size: ${rem("20px")};
  `}
`;

export const Title = styled.p`
  font-weight: 600;
  font-size: ${rem("12px")};
  color: ${themes.text.high};

  ${media.greaterThan("huge")`
    font-size: ${rem("16px")};
  `}
`;

export const Loader = styled.div`
  padding-bottom: 40px;

  ${media.greaterThan("huge")`
    padding-bottom: 56px;
  `}
`;

export const Body = styled.div`
  padding: 0 40px 40px;

  ${media.greaterThan("huge")`
    padding: 0 40px 56px;
  `}
`;

export const Footer = styled.footer`
  padding: 16px 24px;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  border-radius: 0 0 8px 8px;
  background-color: ${rgba(themes.palletes.primary, 0.1)};

  > button {
    &:nth-of-type(2) {
      margin-left: auto;
    }
  }
`;
